
























import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class CalcCardLeft extends Vue {
    @Prop({ default: "sm" }) view: "sm" | "md" | "lg";
    get small() {
        return this.view === "sm";
    }
}
